// extracted by mini-css-extract-plugin
export var planCard = "_sy-0";
export var planList = "_sy-1";